module.exports = __webpack_public_path__ + "static/media/pizzaChampiñonesPiña.ead411e8.png";